// Define a static method for checking if a provided object is null or empty.
if (!Object.isEmpty) {
  Object.isEmpty = function isEmpty(obj) {
    return Object.keys(obj).length === 0 && obj?.constructor === Object;
  };
}
